import BaseNotificationController from './baseNotification_controller'


export default class extends BaseNotificationController {
  static targets = ['container', 'list', 'allread', 'empty', 'count', 'unread']

  // NAVBAR NOTIFICATIONS

  // On the document, not the panel: the panel covers what it is clicked off onto.
  connect() {
    this.closeOnClickOutside = event => {
      if (!this.hasContainerTarget || this.containerTarget.classList.contains('d-none')) return
      if (this.element.contains(event.target)) return

      this.containerTarget.classList.add('d-none')
    }
    document.addEventListener('click', this.closeOnClickOutside)
  }

  disconnect() {
    document.removeEventListener('click', this.closeOnClickOutside)
  }

  // Show/Hide the notifications list in navbar
  toggle() {
    this.containerTarget.classList.toggle('d-none')
    if (!this.containerTarget.classList.contains('d-none')) {
      // Removing the green from "All read"
      this.allreadTarget.classList.remove('allread')

      // Empty the container and show the spinner
      this.listTarget.innerHTML = ''
      this.listTarget.appendChild(this._showSpinner())

      // Get the last 5 notifications
      this._buildGetRequest('/notifications')
        .then(response => response.json())
        .then((data) => {
          if (Object.entries(data).length > 0) {
            this.listTarget.innerHTML = ''
            Object.entries(data).forEach((notification) => {
              const formattedNotification = this._insertNavNotification(notification[1])
              this.listTarget.appendChild(formattedNotification)
            })
          } else {
            // If there's no notifications clone the div with no notification text and insert it
            const noNotifications = this.emptyTarget.cloneNode(true)
            noNotifications.classList.remove('d-none')
            this.listTarget.innerHTML = ''
            this.listTarget.appendChild(noNotifications)
          }
        })
    }
  }

  // Mark all the notifications as read
  readAll(event) {
    this.markAllAsRead(event, this.listTarget)
      .then(done => { if (done) this.allreadTarget.classList.add('allread') })
  }
}
